import { object, string } from "yup"
import { addressSchema } from "./address"
import { maxAge, minAge } from "./birth-date"
import { dateISOString } from "./date-iso-string"
import { emailSchema } from "./email"
import { buildSchema } from "./util/build-schema"

const MAX_AGE = 120
const MIN_AGE = 18

const schema = object({
  firstName: string().required(),
  lastName: string().required(),
  address: addressSchema.required(),
  birthDate: dateISOString()
    .required()
    .test(minAge(MIN_AGE))
    .test(maxAge(MAX_AGE)),
  email: emailSchema.required(),
})

export const trustedContactSchema = buildSchema("TrustedContact", schema)
